import { newRelicJSError } from "../analytics/new_relic_helper";
import { sanitizePhone } from "./sanitize.util";

export function isObject(object) {
	return object != null && typeof object === 'object' && Array.isArray(object) === false;
}

export function isFunction(object) {
	return object && Object.prototype.toString.call(object) === '[object Function]';
}

export function isDate(object) {
	return object && Object.prototype.toString.call(object) === '[object Date]';
}

export function isNumber(object) {
	return object && Object.prototype.toString.call(object) === '[object Number]';
}

export function isRegExp(object) {
	return object && Object.prototype.toString.call(object) === '[object RegExp]';
}

export function isString(object) {
	return object && Object.prototype.toString.call(object) === '[object String]';
}

export function isBoolean(object) {
	return object && Object.prototype.toString.call(object) === '[object Boolean]';
}

export function isArray(object) {
	return Array.isArray(object);
}

export function isUndefined(object) {
	return (typeof object == 'undefined');
}

export function isEmpty(object) {
	if (typeof object == 'undefined') {
		return true;
	}

	if (isFunction(object) || isNumber(object) || isBoolean(object) || isDate(object)) {
		return false;
	}

	if (isString(object)) {
		return object.replace(/\s+/gi, "").length <= 0;
	}

	if (object == null || object.length === 0) {
		return true;
	}

	if (isObject(object)) {
		for (let f in val) {
			return false;
		}

		return true;
	}

	return false;
}

export function isPhoneNumber(string) {
	if (!isString(string)) {
		return false;
	}

	if (isEmpty(string)) {
		return false;
	}

	return /^[0-9]{10}$/.test(sanitizePhone(string));
}

export function isEmail(string) {
	if (!isString(string)) {
		return false;
	}

	if (isEmpty(string)) {
		return false;
	}

	var regex = /^(?!')\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$(?!')/i;

	return regex.test(string);
}

export function isZipCode(string) {
	if (!isString(string)) {
		return false;
	}

	if (isEmpty(string)) {
		return false;
	}

	if (!new RegExp(/^[0-9]{5}$/gi).test(string)) {
		return false;
	}

	return true
}

const STATE_ABBREVIATIONS = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];
export function isStateAbbreviation(string) {
	if (!isString(string)) {
		return false;
	}

	if (string.length !== 2) {
		return false;
	}

	return (STATE_ABBREVIATIONS.indexOf(string.toUpperCase()) > -1);
}
